<!--
  ~ This code is protected by intellectual property rights.
  ~ Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
  ~ © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
  -->

<profile-pds-p-modal p-modal data-protractor-id="global-modal" [open]="openModal()" (dismiss)="closeModal(false)">
  <profile-pds-p-heading p-heading slot="header" size="large" tag="h2" weight="bold">{{ data().title }}</profile-pds-p-heading>
  @if (data().body) {
    <profile-pds-p-text p-text id="modalText" p-text><span [innerHtml]="data().body"></span></profile-pds-p-text>
  }

  <div class="profile:flex profile:flex-col profile:gap-y-fluid-sm profile:sm:gap-x-static-sm profile:sm:flex-row footer">
    @if (data().btnPrimary) {
      <profile-pds-p-button p-button type="button" (click)="closeModal(true)" data-protractor-id="ok-button">
        {{ data().btnPrimary }}
      </profile-pds-p-button>
    }
    @if (data().btnGhost) {
      <profile-pds-p-button p-button type="button" [variant]="'secondary'" (click)="closeModal(false)" data-protractor-id="close-button">
        {{ data().btnGhost }}
      </profile-pds-p-button>
    }
  </div>
</profile-pds-p-modal>
